import {
    UPDATE_THYROID,
    GET_THYROID_TOTAL_SUCCESS,
    GET_THYROID_TOTAL_FAIL,
  } from "../actions/_actionType";
  // "service/actions/_actionType";
  export default function thyroidRe(
    state = {
        thyroidData: {
      },
      total: 0,
      complete: false,
    },
    action
  ) {
    switch (action.type) {
      case UPDATE_THYROID:
        return {
          ...state,
          thyroidData: action.payload.datas,
        };
      case GET_THYROID_TOTAL_SUCCESS:
        return {
          ...state,
          total: action.total,
          complete: true,
        };
      case GET_THYROID_TOTAL_FAIL:
        return {
          ...state,
          total: action.total,
          complete: true,
        };
  
      default:
        return state;
    }
  }
  